module.exports = __webpack_public_path__ + "static/img/8.42afa34.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/3/1/eng/8.png
// module id = NpJl
// module chunks = 0